export enum Permission {
  BASIC = 'basic',
  MASTER = 'master',
  MANAGER = 'manager'
}
